// Shared by browser metadata, legal pages, structured data, and the static build.
// VITE_SITE_URL remains an optional override for another deployment.
export const siteUrl = new URL(
  import.meta.env.VITE_SITE_URL?.trim() || "https://darrenhportfolio.com",
).origin;

export const siteDomain = new URL(siteUrl).hostname;
